import { createSelector, select } from '@ngrx/store';

import { StateSelector } from '@fcom/core/selectors/selector-utils';

import {
  DataState,
  SearchState,
  StatusState,
  TimetableFeatureState,
  TimetableState,
} from '../../interfaces/store.interface';

export const selectTimetableState = (state: TimetableFeatureState): TimetableState => state.timetable;

const _selectSearch = createSelector(selectTimetableState, (state: TimetableState) => state.search);
const _selectData = createSelector(selectTimetableState, (state: TimetableState) => state.data);
const _selectStatus = createSelector(selectTimetableState, (state: TimetableState) => state.status);

export const selectStatusStatus = createSelector(_selectStatus, (state: StatusState) => state.status);
export const selectStatus = (): StateSelector<TimetableFeatureState, StatusState> => select(_selectStatus);
export const selectData = (): StateSelector<TimetableFeatureState, DataState> => select(_selectData);
export const selectSearch = (): StateSelector<TimetableFeatureState, SearchState> => select(_selectSearch);
